<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M16.7507 6.60265C16.7507 3.23236 13.9523 0.5 10.5001 0.5C7.04839 0.5 4.25 3.23236 4.25 6.60265V8.77478C5.66128 9.31466 6.73505 10.5165 7.06256 11.9888C7.92966 11.8342 9.05843 11.7195 10.5001 11.7195C11.9418 11.7195 13.0706 11.8342 13.9377 11.9888C14.2652 10.5161 15.339 9.31426 16.7507 8.77437V6.60265ZM20.5 11.7194C20.5004 10.5978 19.5658 9.68521 18.417 9.68521C16.5791 9.68521 15.0836 11.1454 15.0836 12.94V13.5344C14.3457 13.2768 12.9182 12.94 10.5002 12.94C8.08224 12.94 6.65513 13.2768 5.91678 13.5344V12.94C5.91678 11.1454 4.42133 9.68521 2.58338 9.68521C1.4346 9.68521 0.5 10.5978 0.5 11.7194C0.5 12.5425 1.00334 13.2809 1.78294 13.5978C2.01628 13.693 2.1667 13.9139 2.1667 14.1605L2.58338 15.7879C2.58338 17.2484 3.71632 18.4547 5.16926 18.6162C4.82717 18.7757 4.58883 19.1142 4.58883 19.508C4.58883 20.0565 5.04384 20.4999 5.60469 20.4999C6.16553 20.4999 6.62054 20.0556 6.62054 19.508C6.62054 19.128 6.39887 18.8026 6.0772 18.6349H14.9245C14.6028 18.8013 14.3811 19.1276 14.3811 19.508C14.3811 20.0565 14.8361 20.4999 15.397 20.4999C15.9578 20.4999 16.4128 20.0556 16.4128 19.508C16.4128 19.1134 16.1749 18.7749 15.832 18.6162C17.2837 18.4547 18.4166 17.2484 18.4166 15.7879L18.8333 14.1605C18.8333 13.9139 18.9837 13.6938 19.2171 13.5978C19.9967 13.2813 20.5 12.5425 20.5 11.7194Z"
				:fill="color" 
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgChair',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>